import React from 'react';
import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import { colors } from '@/styles';
import { FCC } from '@/utils/types';

const root = css`
  /* color here is either lowEmphais or disabled */
  color: ${token('color.text.subtlest', colors.N70)};
  white-space: nowrap;
`;

const positionFixStyles = css`
  /* NOTE: Shift to visually align paired text */
  position: relative;
  bottom: -1px;
`;

const ItemHeader: FCC<{
  onClick?: () => void;
  noPositionFix?: boolean;
}> = props => {
  const { noPositionFix, ...rest } = props;
  // eslint-disable-next-line jsx-a11y/heading-has-content
  return <h6 css={[root, noPositionFix ? '' : positionFixStyles]} {...rest} />;
};

export default ItemHeader;
